export const updateHistoryState = (data: Record<string, any>) => {
  const history = window.history
  const state = history.state

  const newState = { ...state, ...data }

  history.replaceState(newState, '', '')
}

export const getHistoryState = (): Record<string, any> | undefined => {
  return typeof window === 'undefined' ? undefined : window.history.state
}
